import DownloadFile from "../../components/Download/DownloadFile";
import "./DataView.css";
import { HORIZONTAL_TABS, SNACKBAR_TYPES } from "../../constants/constant";
import { useEffect, useState } from "react";
import Tabcomponent from "../../components/uikit/components/Tabs/Tab/TabComponent";
import Dashboardicon from "../../assets/images/dashboard.svg";
import tabularicon from "../../assets/images/tabular.svg";
import ButtonComponent from "../../components/uikit/components/Button/ButtonComponent";
import downloadarrow from "../../assets/images/downloadarrow.svg";
import backproject from "../../assets/images/backproject.svg";
import { useDispatch } from "react-redux";
import {
  closeSnackbar,
  openSnackbar,
} from "../../features/snackbar/snackbarslice";
// import { DownloadFileServiceApi } from "../../services/axios";
import { useNavigate } from "react-router-dom";
import LongitudinalChart from '../../components/LongitudinalChart/LongitudinalChart';
import SocialMediaAnalysisViewChart from "../../components/SocialMediaChart/SocialMediaAnalysisViewChart"
import { startLoading, stopLoading } from "../../features/loader/loaderSlice";
import { clarityNav } from "../../services/api/clarityNav/apiService";


function DataView() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedHorizontalTab, setSelectedHorizontalTab] = useState(HORIZONTAL_TABS.TABULAR_VIEW);
  const [downloadFileTrigger] = clarityNav.useDownloadFileServiceApiMutation();
  const [dataFromChild, setDataFromChild] = useState(null);
  const [projectName, setProjectName] = useState(null);
  const [project_id, setProjectId] = useState(null);
  const [PivotCurrentPath, setPivotCurrentPath] = useState(null); // Store currentData from child
  const [responseFilePath, setResponseFilePath] = useState(null);
  const [chartData, setChartData] = useState([
    { wave: "1", option1: 30, option2: 20, option3: 15 },
    { wave: "2", option1: 25, option2: 25, option3: 20 },
    { wave: "3", option1: 35, option2: 15, option3: 25 },
    { wave: "4", option1: 40, option2: 30, option3: 10 },
    { wave: "5", option1: 25, option2: 20, option3: 30 },
    { wave: "6", option1: 30, option2: 25, option3: 20 },
    { wave: "7", option1: 20, option2: 15, option3: 25 },
    { wave: "8", option1: 25, option2: 20, option3: 15 },
    { wave: "9", option1: 30, option2: 25, option3: 20 },
    { wave: "10", option1: 25, option2: 20, option3: 25 }
  ]);
  const [selectedPromptId, setSelectedPromptId] = useState(null);
  const [selectedPrompt, setSelectedPrompt] = useState(null);
  // const PivotCurrentPath ="uploadtest_8b2b0398-d445-443b-b6ab-95894e865a53/PIVOT/1738757746474-Sample-MVOC.xlsx";
  // const [downloadblob] = clarityNav.useDownloadBlobFileMutation({
  //   file_path: PivotCurrentPath,
  // });
  const horizontalLabels = [
    HORIZONTAL_TABS.TABULAR_VIEW,
    HORIZONTAL_TABS.Dashboard_VIEW,
    HORIZONTAL_TABS.LONGITUDINAL_VIEW,
    HORIZONTAL_TABS.SOCIAL_MEDIA_ANALYSIS_VIEW
  ];
  const horizontalIcons = [
    { default: tabularicon, selected: tabularicon },
    { default: Dashboardicon, selected: Dashboardicon },
    { default: tabularicon, selected: tabularicon },
    { default: Dashboardicon, selected: Dashboardicon }
  ];
  const handleHorizontalTabChange = (newValue) => {
    setSelectedHorizontalTab(newValue);
  };
  // Callback function to get data from child
  const handleDataFromChild = (data) => {
    // Find the file with file_type "PIVOT"
    const pivotFile = data?.file_metadata?.find(
      (file) => file?.file_type === "PIVOT"
    );
    const responseFile = data?.file_metadata?.find(
      (file) => file?.file_type === "RESPONSE"
    );
    const projectName = data?.project?.name;
    const projectID = data?.project?.id;
    
    if(projectName) {
      setProjectName(projectName);
    }
    if(projectID) {
      setProjectId(projectID);
    }

    if (pivotFile) {
      setPivotCurrentPath(pivotFile?.file_path);
    }
    if(responseFile){
      setResponseFilePath(responseFile?.file_path);
    }
    
    // Add this if you have longitudinal data in your response
    if (data?.longitudinalData) {
      setChartData(data.longitudinalData);
    }

    // Set prompt data, preferring selectedPromptId/selectedPrompt if present, falling back to promptValue/promptName
    setSelectedPromptId(data?.selectedPromptId || data?.promptValue);
    setSelectedPrompt(data?.selectedPrompt || data?.promptName);

    console.log("Received data:", responseFilePath);
  };

  useEffect(() => {
    if (dataFromChild) {
      // Call handleDataFromChild when dataFromChild changes
      handleDataFromChild(dataFromChild);
    }
  }, [dataFromChild]);

  const renderHorizontalTabContent = () => {
    if (selectedHorizontalTab === HORIZONTAL_TABS.Dashboard_VIEW) {
      return <DownloadFile onDataUpdate={handleDataFromChild} />;
    }
    if (selectedHorizontalTab === HORIZONTAL_TABS.TABULAR_VIEW) {
      return (
        <DownloadFile
          forceTableView={true}
          onDataUpdate={handleDataFromChild}
        />
      );
    }
    if (selectedHorizontalTab === HORIZONTAL_TABS.LONGITUDINAL_VIEW) {
      return (
        <LongitudinalChart 
          data={chartData} 
          project_id={project_id}
          selectedPromptId={selectedPromptId}
          selectedPrompt={selectedPrompt}
        />
      );
    }
    if (selectedHorizontalTab === HORIZONTAL_TABS.SOCIAL_MEDIA_ANALYSIS_VIEW) {
      return (
        <SocialMediaAnalysisViewChart />
      );
    }
  };

  // const handleDownloadClicked = async () => {
    
  //   if (!PivotCurrentPath) {
  //     dispatch(
  //       openSnackbar({
  //         message: "File not found",
  //         type: SNACKBAR_TYPES.ERROR,
  //       })
  //     );
  //     setTimeout(() => {
  //       dispatch(closeSnackbar());
  //     }, 10000);
  //     return;
  //   }

  //   try {
  //     const response = await DownloadFileServiceApi(PivotCurrentPath);

  //     if (response.status === 200) {
  //       const contentType = response.headers["content-type"] || "application/octet-stream";
  //       const fileName = PivotCurrentPath.split("/").pop(); // Extract file name from path
  
  //       // Create Blob and trigger download
  //       const blob = new Blob([response.data], { type: contentType });
  //       const link = document.createElement("a");
  //       link.href = URL.createObjectURL(blob);
  //       link.download = fileName;
  //       document.body.appendChild(link);
  //       link.click();
  
  //       // Cleanup
  //       document.body.removeChild(link);
  //       URL.revokeObjectURL(link.href);
  //     } else {
  //       console.error("File download failed:");
  //     }
  //   } catch (error) {
  //     // dispatch(openSnackbar({ message: error.errorMessage, type: SNACKBAR_TYPES.ERROR }));
  //     console.error("Download failed:", error);
  //   }
  
  // };

  const handleDownloadClicked = async () => {
    // If neither path is available, show an error or return early
    if (!PivotCurrentPath && !responseFilePath) {
      dispatch(
        openSnackbar({
          message: "No files found to download",
          type: SNACKBAR_TYPES.ERROR,
        })
      );
      setTimeout(() => {
        dispatch(closeSnackbar());
      }, 10000);
      return;
    }
     // Dispatch the start loading action
  dispatch(startLoading());
  
    // Helper function to download one file
    const downloadFile = async (filePath) => {
      try {
        const blob = await downloadFileTrigger({
          project_id,
          filePath,
        }).unwrap(); // `blob` is directly the file content
    
        // Create content-type and filename
        const contentType = blob.type || 'application/octet-stream';
        const fileName = filePath.split('/').pop() || 'downloaded_file';
    
        // Create Blob URL and download
        const url = URL.createObjectURL(new Blob([blob], { type: contentType }));
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Download failed:', error);
      }
    };
    try {
       // Download the pivot file if present
    if (PivotCurrentPath) {
      console.log("PivotCurrentPath", PivotCurrentPath);
      await downloadFile(PivotCurrentPath);
    }
  
    // Download the response file if present
    if (responseFilePath) {
      console.log("responseFilePath", responseFilePath);
      await downloadFile(responseFilePath);
    }
    } catch (error) {
      console.error("Download failed:", error);
    }finally{
      dispatch(stopLoading());
    }
  
   
  };
  
 // Handle back button click
 const handleBackClick = () => {
  // Navigate to `/project/${project_id}`
  navigate(`/project/${project_id}`);
};

 

  console.log(projectName)
  console.log(project_id)
  return (
    <>
      <div
        className="DesignQc child-container-designQC"
        style={{
          height:
            selectedHorizontalTab === HORIZONTAL_TABS.Dashboard_VIEW
              ? "auto"
              : "",
        }}
      >
        <div className="backproject" >

        <div className="backarrow"onClick={handleBackClick}>
          <img src={backproject} alt="backproject" style={{ width: '11px', height: '11px' }}/>
          <span className="backproject-text">Back</span>
        </div>
        <div className="projectName-container">
          <div className="divider-line"></div>
          <span className="projectName">{projectName?.charAt(0).toUpperCase() + projectName?.slice(1)}</span>
        </div>
        <div className="download_btn_pattern">
                <img
                  src={downloadarrow}
                  alt="download"
                  style={{
                    width: "15px",
                    height: "15px",
                    position: "relative",
                    right: "-30px",
                    zIndex: "1000",
                    // bottom:"-25px"
                  }}
                />
                <ButtonComponent
                  className="downloadbtn"
                  btnType="secondary"
                  text="Download Output"
                  onClick={handleDownloadClicked}
                  sx={{
                    width: "181px",
                    padding: "13px 13px 13px 30px",
                    height: "38px",
                    paddingleft: "30px",
                  }}
                />
              </div>
        </div>
        <form
          onSubmit={(e) => e.preventDefault()}
          className="external-box container-fluid"
          style={{
            height:
              selectedHorizontalTab === HORIZONTAL_TABS.Dashboard_VIEW
                ? "auto"
                : "",
          }}
        >
          <div
            className={`carddesign w-100 ${
              selectedHorizontalTab !== HORIZONTAL_TABS.Dashboard_VIEW
                ? "form-content"
                : ""
            }`}
          >
            <div className="tab">
              <Tabcomponent
                orientation="horizontal"
                labels={horizontalLabels}
                icons={horizontalIcons}
                onTabChange={handleHorizontalTabChange}
                selectedHorizontalTab={selectedHorizontalTab}
              />
              {/* <div className="download_btn_pattern">
                <img
                  src={downloadarrow}
                  alt="download"
                  style={{
                    width: "15px",
                    height: "15px",
                    position: "relative",
                    right: "-30px",
                    zIndex: "1000",
                    // bottom:"-25px"
                  }}
                />
                <ButtonComponent
                  className="downloadbtn"
                  btnType="secondary"
                  text="Download Output"
                  onClick={handleDownloadClicked}
                  sx={{
                    width: "181px",
                    padding: "13px 13px 13px 30px",
                    height: "38px",
                    paddingleft: "30px",
                  }}
                />
              </div> */}
            </div>

            <div
              className={`${
                selectedHorizontalTab !== HORIZONTAL_TABS.Dashboard_VIEW
                  ? "maincontainer"
                  : "maincontainer-dashboard"
              } `}
            >
              <div
                className={
                  selectedHorizontalTab !== HORIZONTAL_TABS.Dashboard_VIEW
                    ? "container-keyword"
                    : "container2"
                }
                style={{
                  overflow:
                    selectedHorizontalTab !== HORIZONTAL_TABS.Dashboard_VIEW
                      ? ""
                      : "initial",
                  height:
                    selectedHorizontalTab === HORIZONTAL_TABS.Dashboard_VIEW
                      ? "auto"
                      : "",
                }}
              >
                {renderHorizontalTabContent()}
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default DataView;
